import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Button,
  useTheme,
} from '@mui/material';
import { PageLayout } from '../../components/footer/PageLayout';
import { ContentSection, FeatureCard } from '../../components/footer/ContentSection';
import { CTASection } from '../../components/footer/CTASection';

export const AccessibilityPage: React.FC = () => {
  const theme = useTheme();

  const features = [
    {
      icon: "♿",
      title: "Screen Reader Support",
      description: "Our platform is compatible with screen readers and other assistive technologies.",
    },
    {
      icon: "⌨️",
      title: "Keyboard Navigation",
      description: "Navigate our platform using only your keyboard for improved accessibility.",
    },
    {
      icon: "🔍",
      title: "High Contrast Mode",
      description: "Switch to high contrast mode for better visibility and readability.",
    },
    {
      icon: "📱",
      title: "Mobile Accessibility",
      description: "Our mobile app includes accessibility features for on-the-go use.",
    },
  ];

  return (
    <PageLayout
      title="Accessibility"
      subtitle="We're committed to making our platform accessible to everyone, regardless of ability or disability."
      breadcrumbs={[
        { label: "Support", href: "/support" },
        { label: "Accessibility" },
      ]}
    >
      {/* Accessibility Features */}
      <ContentSection
        title="Accessibility Features"
        subtitle="We've built accessibility into every aspect of our platform to ensure everyone can use it effectively."
        backgroundColor={theme.palette.grey[50]}
      >
        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Box sx={{ textAlign: 'center' }}>
                <Box
                  sx={{
                    fontSize: '3rem',
                    mb: 2,
                  }}
                >
                  {feature.icon}
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    mb: 1,
                    color: theme.palette.text.primary,
                  }}
                >
                  {feature.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.text.secondary,
                    lineHeight: 1.6,
                  }}
                >
                  {feature.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </ContentSection>

      {/* CTA Section */}
      <CTASection
        title="Need Accessibility Support?"
        subtitle="If you need help with accessibility features or have suggestions for improvement, please contact us."
        primaryButton={{
          text: "Contact Support",
          href: "/contact",
        }}
        secondaryButton={{
          text: "Accessibility Feedback",
          href: "/feedback",
          variant: "outlined",
        }}
      />
    </PageLayout>
  );
};
